import { createAction, props } from '@ngrx/store';
import { AutoRedemptionSettingType } from '@rd/types/auto-redemption-setting.type';

export enum AutoRedemptionSettingsViewActionTypes {
  ENTER_DETAILS_PAGE = '[AutoRedemptionSettingsView] Enter Details Page',
  ENTER_REVIEW_PAGE = '[AutoRedemptionSettingsView] Enter Review Page',
  ENTER_SUCCESS_PAGE = '[AutoRedemptionSettingsView] Enter Success Page',
}

export const AutoRedemptionSettingsViewEnterDetailsPage = createAction(
  AutoRedemptionSettingsViewActionTypes.ENTER_DETAILS_PAGE,
  props<{
    autoRedemptionSettingType: AutoRedemptionSettingType;
    isEverydaySpend?: boolean;
  }>(),
);

export const AutoRedemptionSettingsViewEnterReviewPage = createAction(
  AutoRedemptionSettingsViewActionTypes.ENTER_REVIEW_PAGE,
  props<{
    autoRedemptionSettingType: AutoRedemptionSettingType;
    isEverydaySpend?: boolean;
  }>(),
);

export const AutoRedemptionSettingsViewEnterSuccessPage = createAction(
  AutoRedemptionSettingsViewActionTypes.ENTER_SUCCESS_PAGE,
  props<{
    autoRedemptionSettingType: AutoRedemptionSettingType;
    isEverydaySpend?: boolean;
  }>(),
);
